import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import PropTypes from 'prop-types';

import './Header.css';
import logo from '../../assets/images/logo-white.png';

export default function Header({ pageName }) {
  return (
    <div className="navigation">
      <Navbar bg="dark" id="navbar" className="d-flex">
        <div className="img-holder">
          <img id="logo" src={logo} alt="logo" />
        </div>
        <div className="page-name ms-auto text-uppercase">
          {pageName}
        </div>
      </Navbar>
    </div>
  );
}

Header.propTypes = {
  pageName: PropTypes.string,
};

Header.defaultProps = {
  pageName: '',
};
